const NotFound = () => {
  return (
    <>
    <div>ページが見つかりません</div>
    </>
  )
}
export default NotFound